import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Navigation from "@/components/sections/Navigation";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import Process from "@/components/sections/Process";
import Industries from "@/components/sections/Industries";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import CTA from "@/components/sections/CTA";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import { siteConfig } from "@/config/site";

function Loader() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      className="vs-loader-bg"
      data-testid="site-loader"
    >
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="flex flex-col items-center"
      >
            <img src={siteConfig.logo} alt="VERYSIGHT" className="h-16 w-auto" />
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: 160 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
          className="mt-6 h-px bg-[#d4af37]"
        />
        <div className="mt-4 text-[10px] tracking-[0.4em] uppercase text-white/50 font-body">
          VerySight
        </div>
      </motion.div>
    </motion.div>
  );
}

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [cookiesAck, setCookiesAck] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1000);
    const ack = localStorage.getItem("vs-cookies");
    if (!ack) setCookiesAck(false);
    return () => clearTimeout(t);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("vs-cookies", "1");
    setCookiesAck(true);
  };

  return (
    <div className="bg-[#0d1220] text-white">
      <AnimatePresence>{loading && <Loader />}</AnimatePresence>

      <Navigation />

      <main data-testid="main-content">
        <Hero />
        <div className="vs-section-divider" />
        <About />
        <Services />
        <WhyChooseUs />
        <Process />
        <Industries />
        <Testimonials />
        <FAQ />
        <CTA />
        <Contact />
      </main>

      <Footer />

      {/* Cookie consent */}
      <AnimatePresence>
        {!cookiesAck && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.4 }}
            className="fixed z-40 bottom-5 right-5 max-w-sm vs-glass-strong rounded-sm p-5"
            data-testid="cookie-consent"
          >
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#d4af37] font-body">
              Privacy
            </div>
            <p className="mt-2 text-sm text-white/75 font-body">
              We use essential cookies to improve your experience. No third-party tracking.
            </p>
            <div className="mt-4 flex items-center gap-3">
              <button
                data-testid="cookie-accept"
                onClick={acceptCookies}
                className="vs-btn-primary py-2 px-4 text-xs"
              >
                Accept
              </button>
              <button
                data-testid="cookie-dismiss"
                onClick={acceptCookies}
                className="text-xs text-white/50 hover:text-white/80"
              >
                Dismiss
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
